/**
 * Logo List Custom Scrollbar
 * Handles custom scrollbar functionality for horizontal scrolling logo lists
 */

class CustomScrollbar {
  constructor(container) {
    this.holderItems = container.querySelector('[data-custom-scrollbar-items]');
    this.scrollbar = container.querySelector('[data-custom-scrollbar]');
    this.scrollbarTrack = container.querySelector('[data-custom-scrollbar-track]');
    this.trackWidth = 0;
    this.scrollWidth = 0;

    if (this.scrollbar && this.holderItems) {
      this.init();
    }
  }

  init() {
    this.attachEvents();
    this.calculateTrackWidth();
  }

  attachEvents() {
    // Listen to scroll events on the logo container
    this.holderItems.addEventListener('scroll', this.calculatePosition.bind(this));
    
    // Recalculate on window resize
    window.addEventListener('resize', this.debounce(() => {
      this.calculateTrackWidth();
      this.calculatePosition();
    }, 250));
  }

  calculateTrackWidth() {
    // Get scrollbar width
    this.scrollbarWidth = this.scrollbar.clientWidth === 0 
      ? this.scrollbar.parentNode.getBoundingClientRect().width 
      : this.scrollbar.clientWidth;

    setTimeout(() => {
      if (this.holderItems.children.length === 0) return;

      // Use native scrollWidth for accuracy as it accounts for gaps, padding, and actual rendered width
      this.scrollWidth = this.holderItems.scrollWidth;
      
      // Calculate track width as percentage
      this.trackWidth = (this.scrollbar.clientWidth / this.scrollWidth) * 100;
      
      // Minimum track width of 5%
      this.trackWidth = this.trackWidth < 5 ? 5 : this.trackWidth;
      
      // Set CSS variable for track width
      this.scrollbar.style.setProperty('--track-width', `${this.trackWidth}%`);

      // Hide scrollbar if content fits (track width >= 100% OR scrollWidth <= clientWidth)
      const contentFits = this.trackWidth >= 100 || this.scrollWidth <= this.holderItems.clientWidth;
      
      if (contentFits) {
        this.scrollbar.classList.add('hide');
        this.holderItems.classList.remove('logo-bar--overflow');
      } else {
        this.scrollbar.classList.remove('hide');
        this.holderItems.classList.add('logo-bar--overflow');
      }
    }, 100);
  }

  calculatePosition() {
    // Calculate scroll position as percentage
    let scrollPercentage = this.holderItems.scrollLeft / 
      (this.holderItems.scrollWidth - this.holderItems.clientWidth);
    
    // Calculate pixel position for the track
    let position = scrollPercentage * (this.scrollbar.clientWidth - this.scrollbarTrack.clientWidth);
    
    // Ensure position is valid
    position = position < 0 ? 0 : position;
    position = isNaN(position) ? 0 : position;
    
    // Set CSS variable for position
    this.scrollbar.style.setProperty('--position', `${Math.round(position)}px`);
  }

  // Debounce utility function
  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', function() {
  // Find all logo list sections
  const logoListSections = document.querySelectorAll('[data-section-type="logo-list-custom"]');
  
  logoListSections.forEach(section => {
    new CustomScrollbar(section);
  });
});

// Reinitialize when Shopify section is loaded (for theme editor)
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    const section = event.target.querySelector('[data-section-type="logo-list-custom"]');
    if (section) {
      new CustomScrollbar(section);
    }
  });
}
